export default {
    getAllEvents: state => {
        return state.events.data;
    },
    getEventsIsLoading: state => {
        return state.events.dataIsLoading;
    },

};